module.exports = "<br/>\n<div class=\"col-sm-12 text-left\">\n\n  <button type=\"button\" (click)=\"startWorkFlow()\" class=\"button-style-margin\">Continue</button>\n  <button type=\"button\" (click)=\"goBackHome()\" class=\"button-style\">Return To Home</button> \n</div>\n  <br/>"


//////////////////
// WEBPACK FOOTER
// ./src/app/renewal/entity-renewal/start-entity-renewal/start-entity-renewal.component.html
// module id = ./src/app/renewal/entity-renewal/start-entity-renewal/start-entity-renewal.component.html
// module chunks = main